export default (previousMsrp, conflictMsrp) => {
  const oldMSRPValue = previousMsrp.isConfidencePrice
    ? previousMsrp.supplierPrice
    : previousMsrp.totalMsrp;
  const newMSRPValue = conflictMsrp.isConfidencePrice
    ? conflictMsrp.supplierPrice
    : conflictMsrp.totalMsrp;

  return newMSRPValue - oldMSRPValue;
};
